import { get, post, put, del } from './request.js';

// post => Signup
export const postSignup = ({ email, password, restaurantName, slug }) =>
  post('/api/v1/auth/signup', { email, password, restaurantName, slug });

// post => Login {double check pathing}
export const postLogin = (email, password) => 
  post('/api/v1/auth/login', { email, password });

// get => Verify {double check pathing}
export const getVerify = () =>
  get('/api/v1/auth/verify');

// Change password (logged in)
export const putChangePassword = (currentPassword, newPassword) =>
  put('/api/v1/auth/change-password', { currentPassword, newPassword });

// Change email
export const putChangeEmail = (newEmail, password) =>
  put('/api/v1/auth/change-email', { newEmail, password });

// Delete account
export const deleteAccount = (password) =>
  del('/api/v1/auth/account', { password });

// Cancel subscription
export const postCancelSubscription = () =>
  post('/api/v1/billing/cancel-subscription');

// Forgot password
export const postForgotPassword = (email) =>
  post('/api/v1/auth/forgot-password', { email });

// Reset password
export const postResetPassword = (token, email, newPassword) =>
  post('/api/v1/auth/reset-password', { token, email, newPassword });
